import { Paper, type PaperProps } from '@mui/material';

/**
 * Wave 3.5 — tonal panel for filters, tables, and interactive sections.
 */
export function TasteSectionCard({
  className = '',
  elevation = 0,
  ...props
}: PaperProps) {
  return (
    <Paper
      elevation={elevation}
      className={`taste-panel taste-rise ${className}`.trim()}
      {...props}
    />
  );
}
